export const ADDRESS_TRUNCATION = {
  PREFIX_LENGTH: 6,
  SUFFIX_LENGTH: 4,
} as const

export const DATE_FORMATS = {
  LOCALE: 'en-US',
  DEFAULT: {
    year: 'numeric' as const,
    month: 'short' as const,
    day: 'numeric' as const,
  },
  COMPACT: {
    month: 'short' as const,
    day: 'numeric' as const,
  },
  FULL: {
    year: 'numeric' as const,
    month: 'long' as const,
    day: 'numeric' as const,
  },
  NUMERIC: {
    year: 'numeric' as const,
    month: '2-digit' as const,
    day: '2-digit' as const,
  },
  WITH_TIME: {
    year: 'numeric' as const,
    month: 'short' as const,
    day: 'numeric' as const,
    hour: 'numeric' as const,
    minute: '2-digit' as const,
  },
} as const

export const PAGINATION = {
  DEFAULT_PREVIEW_COUNT: 5,
  DEFAULT_PAGE_SIZE: 10,
} as const

export const NUMBER_DISPLAY = {
  FALLBACK_VALUE: '0',
  FALLBACK_PERCENTAGE: '0%',
  FALLBACK_CURRENCY: '$0.00',
} as const

export const CURRENCY = {
  SYMBOL: '$',
  DECIMALS: 2,
  USE_GROUPING: true,
} as const
